import { gql } from '@apollo/client';

const getMetricSeriesByCourseQuery = gql`
  query GetMetricSeriesByCourse(
    $course: MongoID!
    $courseCategory: MongoID
    $creator: MongoID
    $isVisibleToStudent: Boolean
  ) {
    getMetricSeriesByCourse(
      course: $course
      courseCategory: $courseCategory
      creator: $creator
      isVisibleToStudent: $isVisibleToStudent
    )
  }
`;

export default getMetricSeriesByCourseQuery;
